export default __webpack_public_path__ + "static/media/Genesis-Shop.410e761e.png";